import { createEventerFn } from './eventer';

import { isDevEnv } from '../utils/common.utils';
import { EntityDeleteStatuses } from 'src/types/common.types';

type SystemDeletedToast = {
  numberOfItems: number;
  status: EntityDeleteStatuses;
};

export const pipeDeletion = createEventerFn(new EventTarget(), 'pipeDeletion', {
  log: true,
  isDev: isDevEnv,
})<SystemDeletedToast>();

export const systemDeletion = createEventerFn(new EventTarget(), 'systemDeletion', {
  log: true,
  isDev: isDevEnv,
})<SystemDeletedToast>();
